import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import WhatsAppFloat from './components/WhatsAppFloat';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import Courses from './pages/Courses';
import BusinessChinese from './pages/BusinessChinese';
import ExamPreparation from './pages/ExamPreparation';
import SpeechEloquence from './pages/SpeechEloquence';
import ImmersionPrograms from './pages/ImmersionPrograms';
import Knowledge from './pages/Knowledge';
import './App.css';
import BackToTop from './components/BackToTop';

const theme = createTheme({
  palette: {
    primary: {
      main: '#07284b',
      light: '#1e40af',
      dark: '#07284b',
      contrastText: '#ffffff',
      background: '#f5f5f5',
    },
    secondary: {
      main: '#1e40af',
    },
    text: {
      primary: '#333333', 
      secondary: '#666666',
    },
    accent: {
      main: '#9f2122',
      light: '#d93a3b',
      dark: '#6b1415',
      contrastText: '#ffffff',
      background: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: 'Arial, sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 700,
    },
    h3: {
      fontWeight: 700,
    },
    h6: {
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          fontWeight: 600,
        },
        sizeLarge: {
          fontSize: '1.2rem',
        },
      },
    },
    MuiContainer: {
      defaultProps: {
        maxWidth: 'xl',
      },
      styleOverrides: {
        root: {
          '&.MuiContainer-maxWidthXl': {
            maxWidth: '1400px',
          },
        },
      },
    },
  },
});

function App() {
  const enableCookieConsent = false; // 临时关闭 Cookie 弹窗
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router basename={process.env.PUBLIC_URL || ''}>
        <Routes>
          <Route path="/" element={
            <div className="App">
              <Header />
              <Home />
              <Footer />
              <BackToTop />
              <WhatsAppFloat phoneNumber="6589208197" />
              {enableCookieConsent && <CookieConsent />}
            </div>
          } />
          <Route path="/aboutus" element={
            <div className="App">
              <Header />
              <AboutUs />
              <Footer />
              <BackToTop />
              <WhatsAppFloat phoneNumber="6589208197" />
            </div>
          } />
          <Route path="/courses" element={
            <div className="App">
              <Header />
              <Courses />
              <Footer />
              <BackToTop />
              <WhatsAppFloat phoneNumber="6589208197" />
            </div>
          } />
          <Route path="/business-chinese" element={
            <div className="App">
              <Header />
              <BusinessChinese />
              <Footer />
              <BackToTop />
              <WhatsAppFloat phoneNumber="6589208197" />
            </div>
          } />
          <Route path="/exam-preparation" element={
            <div className="App">
              <Header />
              <ExamPreparation />
              <Footer />
              <BackToTop />
              <WhatsAppFloat phoneNumber="6589208197" />
            </div>
          } />
          <Route path="/speech-eloquence" element={
            <div className="App">
              <Header />
              <SpeechEloquence />
              <Footer />
              <BackToTop />
              <WhatsAppFloat phoneNumber="6589208197" />
            </div>
          } />
          <Route path="/immersion-programs" element={
            <div className="App">
              <Header />
              <ImmersionPrograms />
              <Footer />
              <BackToTop />
              <WhatsAppFloat phoneNumber="6589208197" />
            </div>
          } />
          <Route path="/contact" element={
            <div className="App">
              <Header />
              <ContactUs />
              <Footer />
              <BackToTop />
              <WhatsAppFloat phoneNumber="6589208197" />
            </div>
          } />
          <Route path="/knowledge" element={
            <div className="App">
              <Header />
              <Knowledge />
              <Footer />
              <BackToTop />
              <WhatsAppFloat phoneNumber="6589208197" />
            </div>
          } />
        </Routes>
      </Router>
    </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
